<template>
  <table class="table b-table table-striped table-hover" v-if="sameOffersTaken">
    <thead>
    <tr>
      <th
        @click="sortBy('app_name')"
        :aria-sort="sortKey === 'app_name' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        App
      </th>
      <th
        @click="sortBy('user_id')"
        :aria-sort="sortKey === 'user_id' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        User
      </th>
      <th
        @click="sortBy('offer_name')"
        :aria-sort="sortKey === 'offer_name' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        Offer
      </th>
      <th
        @click="sortBy('transaction_value')"
        :aria-sort="sortKey === 'transaction_value' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        IAP
      </th>
      <th
        @click="sortBy('publisher_payout')"
        :aria-sort="sortKey === 'publisher_payout' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        Pub. PayOut
      </th>
      <th
        @click="sortBy('formatted_matching_attributes')"
        :aria-sort="sortKey === 'formatted_matching_attributes' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        Matching Attributes
      </th>
      <th
        @click="sortBy('matching_probability')"
        :aria-sort="sortKey === 'matching_probability' ? sortAsc ? 'ascending': 'descending': 'none'"
      >
        Matching Probability
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="sameOfferData in sortedData" :key="`${sameOfferData.user_id}-${sameOfferData.offer_id}`">
      <td>
        <AppWithLogo :appName="sameOfferData.app_name" :appId="sameOfferData.app_id"/>
      </td>
      <td>
        <router-link v-if="canAccess('user_details')"
          :to="{
            name: 'user_details',
            params: {
                userId: sameOfferData.user_id,
            },
          }"
        >
          <UserElement :id="sameOfferData.user_id" :status="sameOfferData.status"/>
        </router-link>
        <span v-else>{{ sameOfferData.user_id }}</span>
      </td>
      <td>
        <OfferElement
          :id="sameOfferData.offer_id"
          :name="sameOfferData.offer_name"
          :status="sameOfferData.offer_status"
          :visibility="sameOfferData.offer_visibility"
          :icon_url="sameOfferData.icon_url"
        />
      </td>
      <td>
        <div class="text-nowrap">{{ sameOfferData.transaction_value | formatCurrency }}</div>
      </td>
      <td>
        <div class="text-nowrap">{{ sameOfferData.publisher_payout | formatCurrency }}</div>
      </td>
      <td>{{ sameOfferData.formatted_matching_attributes ? sameOfferData.formatted_matching_attributes : '-' }}</td>
      <td :class="getProbabilityClass(sameOfferData.matching_probability)">
        <template v-if="sameOfferData.matching_probability">
          {{ sameOfferData.matching_probability }} %
        </template>
        <template v-else>
          -
        </template>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import probabilityMixin from '@/views/users/mixins/probabilityMixin'
import AppWithLogo from '@/views/users/UserDetails/AppWithLogo.vue'
import OfferElement from '@/views/resources/Offers/Parts/OfferElement.vue'

export default {
  components: {OfferElement, AppWithLogo},
  mixins: [probabilityMixin],
  props: {
    sameOffersTaken: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      sortKey: null, // default sort column
      sortAsc: true
    }
  },
  computed: {
    sortedData () {
      if (!this.sortKey) return this.sameOffersTaken

      return [...this.sameOffersTaken].sort((a, b) => {
        let valA = a[this.sortKey] ?? ''
        let valB = b[this.sortKey] ?? ''

        if (typeof valA === 'string' && typeof valB === 'string') {
          valA = valA.toLowerCase()
          valB = valB.toLowerCase()
        }

        if (valA < valB) return this.sortAsc ? -1 : 1
        if (valA > valB) return this.sortAsc ? 1 : -1
        return 0
      })
    }
  },
  methods: {
    sortBy (key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc
      } else {
        this.sortKey = key
        this.sortAsc = true
      }
    }
  }
}
</script>
